import React, { Component, PropTypes } from 'react'

import GridLeftHeader from './grid-left-header'
import GridLeftHeaderDate from '../grid-left-header-date'


class GridLeftHeaderContainer extends Component {

  constructor(props) {
    super(props)

    this.el = null

    this.renderCell = this.renderCell.bind(this)
    this.setRef = this.setRef.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (this.props.gridRecomputeTime !== prevProps.gridRecomputeTime) {
      this.el.recomputeGridSize()
    }
  }

  setRef(ref) {
    this.el = ref
  }

  renderCell({ rowIndex, style }) {
    const date = this.props.items.toIndexedSeq().get(rowIndex)
    return (
      <GridLeftHeaderDate key={date.id} style={style} date={date} />
    )
  }

  render() {
    return (
      <GridLeftHeader {...this.props} renderCell={this.renderCell} setRef={this.setRef} />
    )
  }
}

GridLeftHeaderContainer.propTypes = {
  items: PropTypes.object.isRequired,
  gridRecomputeTime: PropTypes.number.isRequired,
}

export default GridLeftHeaderContainer



/** WEBPACK FOOTER **
 ** ./src/components/grid/grid-left-header/grid-left-header-container.js
 **/